var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 16,
    viewBox: "0 0 35 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_320944331346692880904866050347234443668",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_238074481344970771646207944749575115385",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_337482066165495883116065421545022406146",
    d: "M9.692 12.105c.915 0 1.653-.241 2.215-.724.56-.483.872-1.146.932-1.988h-1.612c-.038.479-.179.831-.423 1.057-.244.227-.614.34-1.112.34-.551 0-.956-.195-1.212-.586-.257-.39-.385-1.008-.385-1.853v-.588c.006-.81.143-1.407.411-1.791.268-.385.67-.577 1.205-.577.495 0 .863.113 1.105.34.242.226.383.593.421 1.1h1.612c-.086-.874-.405-1.553-.957-2.038-.551-.484-1.278-.727-2.18-.727-.651 0-1.223.153-1.715.46-.493.306-.871.746-1.136 1.32-.265.573-.397 1.237-.397 1.99v.477c0 1.177.287 2.102.86 2.777.575.674 1.364 1.011 2.368 1.011zm6.615 0c.838 0 1.506-.27 2.003-.808.498-.539.747-1.253.747-2.143l-.01-.397c-.057-.825-.334-1.478-.83-1.958-.496-.48-1.136-.72-1.92-.72-.552 0-1.036.124-1.454.37-.418.248-.737.597-.959 1.048-.221.451-.332.965-.332 1.543v.071c0 .925.25 1.655.748 2.19.5.536 1.168.804 2.007.804zm0-1.248c-.386 0-.683-.146-.89-.438-.207-.291-.31-.713-.31-1.265 0-.621.103-1.08.31-1.375.207-.295.5-.442.88-.442.383 0 .68.149.892.447.212.298.318.717.318 1.256 0 .634-.106 1.096-.318 1.384-.212.289-.506.433-.882.433zm6.217 1.248c.838 0 1.506-.27 2.004-.808.497-.539.746-1.253.746-2.143l-.01-.397c-.057-.825-.334-1.478-.83-1.958-.495-.48-1.135-.72-1.92-.72-.551 0-1.036.124-1.454.37-.417.248-.737.597-.958 1.048-.222.451-.333.965-.333 1.543v.071c0 .925.25 1.655.749 2.19.499.536 1.167.804 2.006.804zm0-1.248c-.386 0-.682-.146-.89-.438-.207-.291-.31-.713-.31-1.265 0-.621.103-1.08.31-1.375.208-.295.5-.442.88-.442.383 0 .68.149.892.447.212.298.318.717.318 1.256 0 .634-.106 1.096-.318 1.384-.212.289-.506.433-.882.433zM27.866 12V3.75h-1.554V12h1.554z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#454545",
    xlinkHref: "#hinava_random_uuid_337482066165495883116065421545022406146"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_320944331346692880904866050347234443668)",
    xlinkHref: "#hinava_random_uuid_337482066165495883116065421545022406146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hinava_random_uuid_238074481344970771646207944749575115385)",
    d: "M32.5 0C33.88 0 35 1.12 35 2.5v11c0 1.38-1.12 2.5-2.5 2.5h-30C1.12 16 0 14.88 0 13.5v-11C0 1.12 1.12 0 2.5 0h30zm0 1h-30c-.78 0-1.42.595-1.493 1.356L1 2.5v11c0 .78.595 1.42 1.356 1.493L2.5 15h30c.78 0 1.42-.595 1.493-1.356L34 13.5v-11c0-.78-.595-1.42-1.356-1.493L32.5 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCool);
export default __webpack_public_path__ + "static/media/cool.f52d27b7a4005fd46f7585751850ff87.svg";
export { ForwardRef as ReactComponent };